export default "__VITE_ASSET__QYhIY9F___"